import { Link, type LinkProps } from 'react-router-dom'

import { cn } from '@/utils/cn'

import { buttonClass, type ButtonSize, type ButtonVariant } from './styles'

interface LinkButtonProps extends LinkProps {
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
}

/** <Link> do react-router com aparência de botão. */
export function LinkButton({ variant, size, fullWidth, className, ...props }: LinkButtonProps) {
  return <Link className={cn(buttonClass({ variant, size, fullWidth }), className)} {...props} />
}
